import Home from "./MobileHome"
import Footer from "../components/Footer"

function Mobile() {
    return(
        <div className='mobile'>

            <Home />

            <Footer />

        </div>
    )
}

export default Mobile